/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
// component
import { selectCommentSite } from 'state/actions/commentingState/commentingStatus';
import { getCommentingUnitCode } from 'state/actions/commentingState/codeStatus';
import { getConfiguration } from 'state/actions/commentingState/configurationStatus';
import CommentManager from 'pages/dashboard/commenting/commentmanager/commentmanager';
import { changePage, updatePageDetails, displayModal } from "@insticator/insticator-ui";



/* ========== ~~~~~~~~~~ COMMENT MANAGER : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ commentingState, sessionStatus, accountData }) => ({
    sites: accountData.sites,
    status: commentingState.commentingStatus.requestStatus,
    emailSentTo: commentingState.commentingStatus.commentEmailSentTo,
    requestPending: commentingState.commentingStatus.requestPending,
    selectedSite: commentingState.commentingStatus.selectedSite,
    accountUUID: sessionStatus.accountUUID,
    mocked: sessionStatus.mocked,
    mockupGenerator: sessionStatus.mockupGenerator,
    siteUUID: sessionStatus.siteUUID,
    commentingUnitUUID: commentingState.configStatus.commentingUnitUUID,

    fetchingConfigs: commentingState.configStatus.fetchingConfigs,
    fetchingConfigsFailed: commentingState.configStatus.fetchingConfigsFailed
});

const mapDispatchToProps = dispatch => ({
    selectCommentSite: site => dispatch(selectCommentSite(site)),
    displayModal: (isVisible, contentToDisplay, showCloseButton) => dispatch(displayModal(isVisible, contentToDisplay, showCloseButton)),
    getConfiguration: (accountUUID, siteUUID, siteURL, callback) => dispatch(getConfiguration(accountUUID, siteUUID, siteURL, callback)),
    getCommentingUnitCode: (siteUUID) => dispatch(getCommentingUnitCode(siteUUID)),
    moveToPage: (location) => {
        dispatch(updatePageDetails(location));
        dispatch(changePage(location))
    }
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(CommentManager));
